"use strict";

(function () {
  'use strict';

  angular.module('filter.available-options', []).filter('availableOptions', availableOptions);
  availableOptions.$inject = [];
  /* @ngInject */

  function availableOptions() {
    return function (arr) {
      if (arr && Array.isArray(arr)) {
        return arr.filter(function (item) {
          return item.quantity === 0;
        });
      } else {
        return arr;
      }
    };
  }
})();